import { useEffect, useState } from 'react';
import styles from './RotatingSubtitle.module.css';

/** Cross-fades through the given messages on a timer. Static if given one message. */
export function RotatingSubtitle({ messages }: { messages: string[] }) {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (messages.length <= 1) return;
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIndex((i) => (i + 1) % messages.length);
        setVisible(true);
      }, 600);
    }, 4000);
    return () => clearInterval(interval);
  }, [messages]);

  return (
    <p className={`${styles.subtitle} ${visible ? styles.subtitleVisible : styles.subtitleHidden}`}>
      {messages[index]}
    </p>
  );
}
